import { useEffect, useCallback } from 'react';
import { getStyledSystemProps } from '~/utils/styled-system';
import { StyledSelect, StyledSelectProps } from '../select.style';

interface Props extends StyledSelectProps {
  options?: {
    id: number;
    lastFour: string;
    source: string;
  }[];
  onChange: (id: number, options: { isValid: boolean; name: 'existingPaymentMethodId' }) => void;
  value?: number;
}

export const PaymentMethods = ({ options = [], onChange, value, ...rest }: Props) => {
  const handleChange = useCallback(
    (id: string | number) => {
      onChange(Number(id), { isValid: true, name: 'existingPaymentMethodId' });
    },
    [onChange],
  );

  useEffect(() => {
    const firstId = options?.[0]?.id;
    if (firstId) handleChange(firstId);
  }, [handleChange, options]);

  return (
    <StyledSelect
      {...getStyledSystemProps(rest)}
      label="Existing payment methods"
      minHeight="auto"
      name="existingPaymentMethods"
      options={options.map(pm => ({
        text: pm.lastFour
          ? `${pm.source || 'Payment'} ending in •••• ${pm.lastFour}`
          : `${pm.source || 'Payment'}`,
        value: pm.id,
      }))}
      value={value}
      onChange={handleChange}
    />
  );
};
